import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // Import i18n here to ensure it's initialized
import {Provider, useSelector} from 'react-redux';
import {store, RootState, persistor} from './redux/store'; // Import your store and RootState
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {lightTheme, darkTheme} from './styles/theme'; // Import your themes
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n'; // Import your i18n instance
import {PersistGate} from 'redux-persist/integration/react';
import {LicenseInfo} from '@mui/x-license';
import {initGTM} from './utils/gtm';

LicenseInfo.setLicenseKey(
  process.env.REACT_APP_MUI_X_PRO_LICENSE_KEY as string
);

// A wrapper component to connect to the Redux store and provide the theme
const Root: React.FC = () => {
  // Get the theme mode from the Redux store
  const themeMode = useSelector((state: RootState) => state.theme.mode);

  useEffect(() => {
    initGTM();
  }, []);

  return (
    <ThemeProvider theme={themeMode === 'light' ? lightTheme : darkTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

// Render the application, wrapped with the Redux Provider and I18nextProvider
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <Root />
      </I18nextProvider>
    </PersistGate>
  </Provider>
);
